module.exports = __webpack_public_path__ + "assets/img/gift-6-d-37bd614b.png";